import React, { useEffect } from 'react';
import { Input, Select, Space } from 'antd';

const { Search } = Input;
const { Option } = Select;

const SearchComponent = ({
  searchColumn,
  setSearchColumn,
  searchText,
  setSearchText,
  searchOptions,
  placeholder,
  defaultSearchColumn,
}) => {
  useEffect(() => {
    if (defaultSearchColumn) {
      setSearchColumn(defaultSearchColumn);
    }
  }, [defaultSearchColumn, setSearchColumn]);

  const selectedOption = searchOptions.find(option => option.value === searchColumn);
  const searchPlaceholder = selectedOption ? selectedOption.label : '검색';

  return (
    <div style={{ width: '100%' }}>
      <Space wrap style={{ width: '100%' }}>
        <div style={{ flex: '0 0 120px', minWidth: 120 }}>
          <Select
            value={searchColumn}
            onChange={setSearchColumn}
            style={{ width: '100%' }}
          >
            {searchOptions.map(option => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
        </div>
        <div style={{ flex: '1 1 200px', minWidth: 120 }}>
          <Search
            placeholder={placeholder || `${searchPlaceholder} 검색`}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: '100%' }}
            allowClear
          />
        </div>
      </Space>
    </div>
  );
};

export default SearchComponent;
